import { Component, OnInit } from '@angular/core';
import { PeculioService } from '../../services/previdencia/peculio.service';
@Component({
  selector: 'app-peculio',
  templateUrl: './peculio.component.html',
  styleUrls: ['./peculio.component.css']
})
export class PeculioComponent implements OnInit {
  public peculio: any = null;
  constructor(private peculioService: PeculioService) { }
  ngOnInit() {
    this.peculioService.getPeculio().subscribe(
      (res: any) => {
        this.peculio = res.sort((actual: any, last: any) => {
          if (actual.tipoSegurado === "TITULAR" && last.tipoSegurado !== "TITULAR") {
            return -1;
          }
          if (actual.tipoSegurado !== "TITULAR" && last.tipoSegurado === "TITULAR") {
            return 1;
          }
          return 0;
        })
      });
  }
}
